import {
    AfterViewChecked,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild
} from '@angular/core';
import {ListCardMessage} from "./list-card-message";

@Component({
    selector: 'list-card',
    templateUrl: './list-card.component.html',
})
export class ListCardComponent implements AfterViewChecked{

    @Input() listCard: ListCardMessage;
    @Output() remove:EventEmitter<any> = new EventEmitter<any>();
    @Output() edit:EventEmitter<any> = new EventEmitter<any>();
    @Input() cardHeight: number;
    private padding: number = 55;
    collapsed:boolean = true;
    private cardMaxHeight:number;

    @ViewChild('content')content: ElementRef;

    constructor(private changeDetectorRef:ChangeDetectorRef) {
    }

    ngAfterViewChecked(): void {
        this.cardMaxHeight = this.content.nativeElement.scrollHeight;
        this.changeDetectorRef.detectChanges();
    }

    showMoreButtons(): boolean{
        return (this.cardHeight + this.padding) < this.cardMaxHeight;
    }

    editCallback(){
        this.edit.next();
    }

    removeCallback(){
        this.remove.next();
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/list-card/list-card.component.ts